import React from "react";
import { Col } from "reactstrap";
import "./index.scss";

const FooterDescription = ({ color = "dark" }) => {
  const textColor = color === "dark" ? "text black-text" : "text white-text";

  return (
    <>
      <Col lg="12" md="12" sm="12" className={`${textColor} p-0`}>
        The MYTT app is an initiative of National Veterans Transition Services,
        inc. aka REBOOT and Infojini to assist you in making a successful
        transition from the military to civilian life.
      </Col>
      <Col lg="12" md="12" sm="12" className={`${textColor} p-0`}>
        Use of{" "}
        <a 
        href="http://mytt365.online" 
        target="_blank" rel="noreferrer"
        className="subHeader_Link"
        >
          mytt365.online
        </a>{" "}
        does not imply DoD endorsement.
      </Col>
    </>
  );
};

export default FooterDescription;
